export const CHATROOMS = 'CHATROOMS';
export const CHATROOMS_WITH = 'CHATROOMS_WITH';
export const CHATROOM = 'CHATROOM';
export const CHATMESSAGES = 'CHATMESSAGES';
export const CHATMESSAGES_ISLOADING = 'CHATMESSAGES_ISLOADING';
export const CHATMESSAGES_COUNT = 'CHATMESSAGES_COUNT';
export const POST_PROCESSING = 'POST_PROCESSING';
export const CHATMESSAGES_SYSTEM_TYPE = 'CHATMESSAGES_SYSTEM_TYPE';
export const CHATMESSAGES_SYSTEM_TYPE_ISLOADING =
  'CHATMESSAGES_SYSTEM_TYPE_ISLOADING';
export const CHATMESSAGES_SYSTEM_TYPE_COUNT = 'CHATMESSAGES_SYSTEM_TYPE_COUNT';
export const CHATMESSAGE_SYSTEM_TYPE = 'CHATMESSAGE_SYSTEM_TYPE';
export const CHATROOM_WATCH = 'CHATROOM_WATCH';
export const RESET_CHAT_CACHE_LIST = 'RESET_CHAT_CACHE_LIST';

const getters = {
  [CHATROOMS]: state => state.chatrooms,
  [CHATROOMS_WITH]: state => state.chatrooms_with,
  [CHATROOM]: state => state.chatroom,
  [CHATMESSAGES]: state => state.chatmessages.data,
  [CHATMESSAGES_ISLOADING]: state => state.chatmessages.isLoading,
  [CHATMESSAGES_COUNT]: state => state.chatmessages.totalElements,
  [POST_PROCESSING]: state => state.post_processing,
  [CHATMESSAGES_SYSTEM_TYPE]: state => state.chatmessages_system.data,
  [CHATMESSAGES_SYSTEM_TYPE_ISLOADING]: state =>
    state.chatmessages_system.isLoading,
  [CHATMESSAGES_SYSTEM_TYPE_COUNT]: state =>
    state.chatmessages_system.totalElements,
  [CHATMESSAGE_SYSTEM_TYPE]: state => state.chatmessage_system,
  [CHATROOM_WATCH]: state => state.chatroom_watch,
  [RESET_CHAT_CACHE_LIST]: state => state.resetChatCacheList,
};

export default getters;
